import fetch from 'isomorphic-fetch'
import { connect } from 'react-redux'

import * as Jsx from './index.jsx'
const RxComponent = global.rootRequire('components/shares/rxComponent').default

const { rxsetLocal, rxgetLocal } = global.rootRequire('classes/request')
const { setComp, rxnavToggle, rxnavClose, netaloginAction } = global.rootRequire('redux')
const dHeaders = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8' }

const crypto = require('crypto')

class Component_ extends RxComponent {
  constructor(props, context) {
    super(props, context, Jsx)
    this.keyClickFunction = this.keyClickFunction.bind(this);
    this.token = ''
    this.tokenLogin = ''
    this.state = global.rootContext(this.props.staticContext) || {
      flagStep: 0,
      inputUsername: '',
      inputFullname: '',
      inputPass: '',
      errMess: '',
      errMessDesc: '',
      flagShowPass: false,
    }
  }

  componentDidMount() {
    rxsetLocal('rxusers', JSON.stringify({ status: false, users: {}, ids: [] }))
    rxsetLocal('netaLastSeenMessObj', JSON.stringify({}))
    this.fetchSession()
    document.addEventListener("keydown", this.keyClickFunction, false);

  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keyClickFunction, false);
  }

  checkAuth() {
    if (global.rxu.get(this.props, 'netaauth.user.id')) {
      this.props.setComp('chat')
    }
  }

  keyClickFunction(event) {
    if (event.keyCode === 13) {
      this.onClickRegister()
    }
  }

  onClickDisplayPass() {
    let flagShowPass = this.state.flagShowPass
    this.setState({
      flagShowPass: !flagShowPass
    })
  }

  changeCheckedSaveMe() {
    let checkSaveLogin = this.state.checkSaveLogin
    this.setState({
      checkSaveLogin: !checkSaveLogin
    })
  }

  genSignature() {
    let appID = global.rxu.config.application_id
    let appKey = global.rxu.config.auth_key
    let timestamp = Math.floor(Date.now() / 1000)
    let nonce = Math.floor(Math.random() * 89999) + 10000
    let content = "application_id=" + appID + "&auth_key=" + appKey + "&nonce=" + nonce + "&timestamp=" + timestamp
    let signalstr = crypto.createHmac('sha1', appKey).update(content).digest('hex')

    let result = {
      'application_id': appID,
      'auth_key': appKey,
      'nonce': nonce,
      'signature': signalstr,
      'timestamp': timestamp
    }
    return result
  }


  fetchSession() {
    let params = this.genSignature()
    fetch(global.rxu.config.base_api_neta + '/api/session.json', {
      method: 'POST',
      body: JSON.stringify(params),
      headers: dHeaders
    }).then((res) => { return res.json() })
      .then((json) => {
        if (!json.Code || json.Code === 200) {
          this.token = json.token
        }
      }).catch(er => console.log(er))
  }

  onClickRegister() {
    let username = this.state.inputUsername
    let password = this.state.inputPass
    let fullname = this.state.inputFullname

    if (!username) {
      this.setState({ errMess: 'UserName không được để trống' })
      setTimeout(() => { this.setState({ errMess: '' }) }, 3000)
    } else if (!password) {
      this.setState({ errMess: 'Password không được để trống' })
      setTimeout(() => { this.setState({ errMess: '' }) }, 3000)
    } else if (!fullname) {
      this.setState({ errMess: 'Fullname không được để trống' })
      setTimeout(() => { this.setState({ errMess: '' }) }, 3000)
    } else {
      this.handleRegister(username, password, fullname)
    }
  }

  handleRegister(username, password, fullname) {
    let params = { username: username, password: password, fullname: fullname }
    if (this.token) {
      let headers = { 'TC-Token': this.token, ...dHeaders }
      fetch(global.rxu.config.base_api_neta + '/api/register.json', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: headers
      })
        .then((res) => { return res.json() })
        .then((json) => {
          if (json) {
            if (json.Code === 1012) {
              this.setState({
                errMess: 'Tài khoản đã tồn tại',
              })
              setTimeout(() => { this.setState({ errMess: '' }) }, 100)
            } else {
              if (json.token) {
                this.setState({ errMess: 'Đăng ký thành công, vui lòng đăng nhập' })
                setTimeout(() => {
                  this.setState({ errMess: '' })
                  this.props.onLogin() // Call the onLogin prop to redirect to login page
                }, 100)
              } else {
                this.setState({ errMess: 'Đăng ký thất bại, vui lòng thử lại' })
                setTimeout(() => { this.setState({ errMess: '' }) }, 100)
              }
            }
          }
        }, (er) => {
          this.setState({ errMess: 'Đăng ký thất bại, vui lòng thử lại' })
          setTimeout(() => { this.setState({ errMess: '' }) }, 100)
        })
    }
  }

  openExternalLink(url) {
    if (window && window.ipcRenderer && url) {
      window.ipcRenderer.send('open-external-link', { link: url })
    } else if (window && url) {
      window.open(url, '_blank')
    }
  }


  updateInput(inputName, e) {
    let state = {}
    state[inputName] = e.target.value
    this.setState(state)
  }

  render() {
    return this.renderComponent()
  }
}

const mapStateToProps = (state, ownProps) => ({
  auth: state.auth,
  favorite: state.favorite,
  netaauth: state.netaauth
})

const mapDispatchToProps = {
  rxnavClose,
  rxnavToggle,
  netaloginAction,
  setComp
}

const ComponentWrapped = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component_)

export default ComponentWrapped
